export enum ChipVariant {
  BRAND = 'brand',
  BRAND_CONTRAST = 'brand-contrast',
  LIGHT = 'light',
  DARK = 'dark',
  INFO = 'info',
  TERTIARY = 'tertiary',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
  YELLOW_LIGHT = 'yellow-light',
  GREEN_LIGHT = 'green-light',
  BLUE_LIGHT = 'blue-light',
  PURPLE_LIGHT = 'purple-light',
  DARK_LIGHT = 'dark-light',
  INFO_CONTRAST = 'info-contrast',
}
